import { useState, useEffect } from 'react';
import HelloBar from './common/Hellobar';

const MenubarAd1 = ({ home, challenges, programs, casestudy, bookDemo, showHelloBar }) => {

    const [open, setOpen] = useState(false)
    const [a, setA] = useState('')
    const [b, setB] = useState('')
    const [c, setC] = useState('')

    const handleDropdown = () => {
        setOpen(!open)
    }

    useEffect(() => {
        if(open){
            setA('a')
            setB('b')
            setC('c')
        }
        else{
            setA('')
            setB('')
            setC('')
        }
      }, [open])


  return (
    <div className='headerWrapper ad-landing'>
        <header className="header_area header_stick nav-black brad48" id= "headerarea">
            {showHelloBar && <div className="mb-2"><HelloBar /></div>}
            <nav className='navbar navbar-expand-lg menu_center mainsite1'>
                <div className='container custom_container'>
                    <div className='site-mast-left'>
                        <a href="#" className="navbar-brand sticky_logo">
                            <img
                loading="lazy" width="210" height="45" className="site-logo" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto,w_220/VantageFit/website/01-vantagefit-logo-2_compress" alt= "" />
                        </a>
                    </div>
                    <div className='justify-content-center vfit-main'>
                        <div id='menu-main-menu-global' className='d-none d-lg-flex navbar-nav menu  ml-auto'>
                            <div className='nav-home menu-item nav-item HeaderN justify-content-center align-items-center'>
                                <a href={home} className='site-nav-item'>Home</a>
                                <a href={challenges} className='site-nav-item'>Challenges</a>
                                <a href={programs} className='site-nav-item'>Programs</a>
                                <a href={casestudy} className='site-nav-item'>Testimonials</a>
                                <a href={bookDemo} className='menu_cus btn_get btn-meta btn_hover menu-top'>Book a Demo</a>
                            </div>
                        </div>
                    </div>
                        <div className='d-flex d-lg-none align-items-center justify-content-end'  onClick={handleDropdown}>
                            <a href='' className='text-white d-flex flex-column justify-content-center align-items-center' style={{ backgroundColor: '#FBECEC', borderRadius: '50%', padding: '8px 10px', height: '45px', width: '45px' }}>
                                <div className="icon-1" id={a}></div>
                                <div className="icon-2" id={b}></div>
                                <div className="icon-3" id={c}></div>
                            </a>
                        </div>
                </div>

            </nav>
        </header>
        <div className={open ? 'dropdownActive gcwmobile-menu bg-white pt-2 d-flex flex-column overflow-x-hidden pb-5' : 'dropdown overflow-hidden h-0'}>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={home} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Home</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={challenges} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Challenges</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={programs} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Programs</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={casestudy} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Casestudy</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={bookDemo} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Book a Demo</a></div>
            </div>
    </div>
  )
}

export default MenubarAd1
